module.exports = __webpack_public_path__ + "h5/img/logo.e47e2904.png";